import salesApi from '@/api/sales.api';

const state = {
  articles: [],
  article: null,
  status: '',
};

const getters = {
  articles: state => state.articles,
  article: state => state.article,
  status: state => state.status,
};

const actions = {
  async findArticles({ commit }, { query, sort }) {
    try {
      commit('SET_STATUS', 'LOADING');
      const response = await salesApi.findArticles({ query, sort });
      commit('SET_ARTICLES', response.articles);
      commit('SET_STATUS', 'FINISHED');
    } catch (error) {
      commit('SET_STATUS', 'ERROR');
      console.error('Error fetching articles:', error);
      throw error;
    }
  },

  async getArticle({ commit }, articleId) {
    try {
      commit('SET_STATUS', 'LOADING');
      const response = await salesApi.getArticle(articleId);
      commit('SET_ARTICLE', response.article);
      commit('SET_STATUS', 'FINISHED');
    } catch (error) {
      commit('SET_STATUS', 'ERROR');
      console.error('Error fetching article:', error);
      throw error;
    }
  },

  async createArticle({ dispatch }, article) {
    try {
      await salesApi.createArticle(article);
      dispatch('findArticles', { query: '' });
    } catch (error) {
      console.error('Error creating article:', error);
      throw error;
    }
  },

  async updateArticle({ dispatch }, article) {
    try {
      await salesApi.updateArticle(article._id, article);
      dispatch('findArticles', { query: '' });
    } catch (error) {
      console.error('Error updating article:', error);
      throw error;
    }
  },

  async activateArticle({ dispatch }, articleId) {
    try {
      await salesApi.updateArticle(articleId, { isActive: true });
      dispatch('findArticles', { query: '' });
    } catch (error) {
      console.error('Error activating article:', error);
      throw error;
    }
  },

  async deactivateArticle({ dispatch }, articleId) {
    try {
      await salesApi.deleteArticle(articleId);
      dispatch('findArticles', { query: '' });
    } catch (error) {
      console.error('Error deactivating article:', error);
      throw error;
    }
  },
};

const mutations = {
  SET_ARTICLES(state, articles) {
    state.articles = articles;
  },
  SET_ARTICLE(state, article) {
    state.article = article;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}; 